var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datepicker',{attrs:{"disabled-dates":_vm.disabledDates,"placeholder":_vm.placeholder,"value":_vm.data,"language":_vm.ru,"monday":true,"format":_vm.customFormatter},on:{"selected":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }